import React from "react";
import {Animated} from "react-native";

export const DrawerAnimationContext = React.createContext(null);

export const animationRef = React.createRef(null);

export const startValues = {
    width: 72,
    height: "100vh",
};

export const endValues = {
    width: 300,
    height: "100vh",
}

export const getInitialValue = () => {
    return new Animated.Value(0);
}


export const DrawerAnimationContextProvider = ({ children }) => {
    const drawerContextValue = React.useRef(getInitialValue()).current;
    return <DrawerAnimationContext.Provider value={ drawerContextValue }>{ children }</DrawerAnimationContext.Provider>
}


export const useDrawerAnimationContext = () => {
    const animation = React.useContext(DrawerAnimationContext);

    return React.useRef(({
            animation,
            animationRef,
            drawerStyle: {
                clipPath: undefined,
                width: animation.interpolate({
                    inputRange: [0, 1],
                    outputRange: [`${startValues.width}px`, `${endValues.width}px`],
                }),
            }
        })
    ).current;
}